import React, { Key, useEffect, useState } from "react";
import {
    useGetUserInfoQuery,
    useSetUserCountryMutation,
} from "../../../app/rootReducer";
import { CountryInterface } from "../../interfaces/shared/CountryInterface";
import { useStringTranslation } from "../../hooks/useStringTranslation";

interface CountryPickerProps {
    active: boolean;
    setActive: React.Dispatch<React.SetStateAction<boolean>>;
    setLanguageActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const openCountryPicker = (
    active: boolean,
    setActive: React.Dispatch<React.SetStateAction<boolean>>,
    setLanguageActive: React.Dispatch<React.SetStateAction<boolean>>,
): void => {
    setActive(!active);
    setLanguageActive(false);
};

const setCountry = (
    country: CountryInterface,
    setUserCountryTrigger: ReturnType<typeof useSetUserCountryMutation>[0],
): void => {
    void setUserCountryTrigger(country.id);
};

export const CountryPicker: React.FC<CountryPickerProps> = ({
    active,
    setActive,
    setLanguageActive,
}) => {
    const { t } = useStringTranslation();
    const [setUserCountryTrigger, { isLoading: isCountryUpdating }] =
        useSetUserCountryMutation();

    const { data } = useGetUserInfoQuery();
    const { countries, activeCountry } = data || {
        countries: [],
        activeCountry: null,
    };

    const [activeCountryState, setActiveCountryState] =
        useState<CountryInterface | null>(activeCountry);

    useEffect(() => {
        setActiveCountryState(activeCountry);
    }, [activeCountry]);

    if (!countries || countries.length <= 1 || !activeCountryState) {
        return null;
    }

    return (
        <div className="c-language-picker__wrapper c-language-picker__wrapper--country">
            <div className="c-language-picker__label">
                <span>{t("country")}:</span>
            </div>
            <div
                className={
                    "c-language-picker c-language-picker--country " +
                    (active ? "is-active" : "")
                }
            >
                <button
                    className="c-language-picker__btn"
                    disabled={isCountryUpdating}
                    onClick={() =>
                        openCountryPicker(active, setActive, setLanguageActive)
                    }
                >
                    <div>
                        <span>{activeCountryState.name}</span>
                    </div>
                    <img
                        className="img-arrow"
                        src="/images/arrow-down.svg"
                        alt=""
                    />
                </button>
                <div className="c-language-picker__container">
                    <ul>
                        {countries
                            .filter(
                                (country: CountryInterface) =>
                                    country.id !== activeCountryState.id,
                            )
                            .map(
                                (
                                    country: CountryInterface,
                                    index: Key | null | undefined,
                                ) => (
                                    <li
                                        key={index}
                                        onClick={() => {
                                            setActive(!active);
                                            setCountry(
                                                country,
                                                setUserCountryTrigger,
                                            );
                                        }}
                                    >
                                        <span>{country.name}</span>
                                    </li>
                                ),
                            )}
                    </ul>
                </div>
            </div>
        </div>
    );
};
